var ShareModule = /** @class */ (function () {
    function ShareModule() {
    }
    return ShareModule;
}());
export { ShareModule };
